import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n    top: 10px;\n  "]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n    top: 12px;\n  "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n    // position: static;\n  "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n    left: 30px;\n    top: 22px;\n    .main-menu__logo img{\n      max-width: 60px;\n    }\n  "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  // top: -8px;\n  top: 42px;\n  left: 50px;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 160%;\n  "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  font: 16px ", ";\n  line-height: 1.6em;\n  color: #5b6870;\n  ", "\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 100%;\n  "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  font: 24px ", ";\n  line-height: 1em;\n  margin-bottom: 8px;\n  ", "\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n    max-width: 180px;\n  "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n    max-width: 240px;\n  "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto 40px;\n  "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    img {\n      margin: auto;\n      max-height: 400px;\n    }\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 45px;\n  img {\n    max-width: 100%;\n    max-height: 650px;\n    height: auto;\n    width: auto;\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  outline: none;\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n    padding: 33px 24px 80px;\n  "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: 138px 64px 100px;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 140px;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  width: 42%;\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 170px 120px 120px;\n  .checkout-slider {\n    width: 100%;\n  }\n  .slick-dots {\n    bottom: -45px;\n    li.slick-active button:before {\n      color: ", ";\n      opacity: 1;\n    }\n    button:before {\n      color: ", ";\n      opacity: 0.5;\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n    line-height: 16px;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 20px;\n  display: block;\n  padding: 0 5px 8px;\n  position: relative;\n  font-size: 20px;\n  line-height: 1em;\n  &:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 2px;\n    background-color: ", ";\n  }\n  ", "\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    button:not(:first-child) {\n      margin-top: 21px;\n    }\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 30px;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    button {\n      span {\n        padding: 0;\n      }\n    }\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    button {\n      padding: 13px 33px;\n      span {\n        padding: 0;\n        font-size: 13px;\n        line-height: 13px;\n      }\n    }\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  button {\n    color: ", ";\n    background-color: rgba(195, 76, 62, 0.15);\n    &:hover {\n      svg * {\n        stroke: ", ";\n      }\n    }\n    span {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n    }\n  }\n  svg {\n    display: block;\n    margin-left: 10px;\n    * {\n      transition: 0.3s;\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 160%;\n    margin-bottom: 8px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 17px;\n    font-size: 16px;\n    line-height: 160%;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  font: 20px ", ";\n  margin-bottom: 24px;\n  line-height: 1.6em;\n  span {\n    font-weight: ", ";\n  }\n  ", "\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 36px;\n    font-size: 24px;\n    line-height: 100%;\n    div {\n      margin-bottom: 11px;\n    }\n    span {\n      font-size: 14px;\n      line-height: 100%;\n    }\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    div {\n      margin: 35px auto 0px;\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    // margin-bottom: 57px;\n    margin-bottom: 40px;\n    font-size: 36px;\n    line-height: 100%;\n    img {\n      max-height: 86px;\n    }\n    div {\n      margin: 23px auto 0;\n    }\n    span {\n      font-size: 14px;\n      line-height: 100%;\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  font: 48px ", ";\n  line-height: 1em;\n  margin-bottom: 85px;\n  div {\n    margin: 35px auto 13px;\n  }\n  span {\n    font: 18px ", ";\n    opacity: 0.8;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    padding: 44px 0 40px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 0 66px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 140px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 180px;\n  padding-top: 170px;\n  padding-bottom: 40px;\n  flex-grow: 1;\n  text-align: center;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    .share-project {\n      &__share {\n        &-icons {\n          margin-bottom: 42px;\n        }\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    .share-project {\n      &__share {\n        &-icons {\n          margin-bottom: 108px;\n          &-other {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  min-height: 100vh;\n  display: flex;\n\n  .share-project {\n    &__share {\n      &-button {\n        margin: 6px;\n      }\n      &-icons {\n        margin-bottom: 153px;\n        &-other {\n          justify-content: center;\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.xxLargeScreen(_templateObject2()), media.largeScreen(_templateObject3()), media.mediumScreen(_templateObject4()));
export var Left = styled.div(_templateObject5(), media.xxLargeScreen(_templateObject6()), media.largeScreen(_templateObject7()), media.mediumScreen(_templateObject8()));
export var ThankYouHeader = styled.div(_templateObject9(), function (props) {
  return props.theme.typography.thinFontFamily;
}, function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject10()), media.largeScreen(_templateObject11()), media.mediumScreen(_templateObject12()));
export var Paragraph = styled.p(_templateObject13(), function (props) {
  return props.theme.typography.extraFontFamily;
}, function (props) {
  return props.theme.typography.boldFontWeight;
}, media.xxLargeScreen(_templateObject14()), media.mediumScreen(_templateObject15()));
export var Download = styled.div(_templateObject16(), function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.white;
}, media.xxLargeScreen(_templateObject17()), media.mediumScreen(_templateObject18()));
export var Buttons = styled.div(_templateObject19(), media.xxLargeScreen(_templateObject20()), media.mediumScreen(_templateObject21()));
export var Link = styled.button(_templateObject22(), function (props) {
  return props.theme.colors.red;
}, media.xxLargeScreen(_templateObject23()));
export var SliderWrapper = styled.div(_templateObject24(), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.red;
}, media.xxLargeScreen(_templateObject25()), media.largeScreen(_templateObject26()), media.mediumScreen(_templateObject27()));
export var Slide = styled.div(_templateObject28());
export var SliderImage = styled.div(_templateObject29(), media.xxLargeScreen(_templateObject30()), media.largeScreen(_templateObject31()), media.mediumScreen(_templateObject32()), media.extraSmallScreen(_templateObject33()));
export var SliderTitle = styled.div(_templateObject34(), function (props) {
  return props.theme.typography.thinFontFamily;
}, media.xxLargeScreen(_templateObject35()));
export var SliderHint = styled.div(_templateObject36(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject37()));
export var Logo = styled.div(_templateObject38(), media.xxxLargeScreen(_templateObject39()), media.xLargeScreen(_templateObject40()), media.xLargeScreen(_templateObject41()), media.mediumScreen(_templateObject42()));